import * as Logger from "./logger.js";
import { HSComponent } from "./component.js";
import { HSButton } from "./button.js";
import styles from "./rounded-button.css";
import template from "./rounded-button.html";

export class HSRoundedButton extends HSButton {
    constructor() {
        super();
    }

    async onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
        super.onLoad();
    }
}
customElements.define("hs-rounded-button", HSRoundedButton);
